const config = {
  bpexpertsinternal: "sk-proj-Ss4cuELzstjOtugkMNFgT3BlbkFJ6LoAAIVn6PoyFlGwgEw0", //bpexpertsinternal-openAI
  newrelease: "sk-proj-TEjiPEjp7JVK9U7tZPoDT3BlbkFJuLVrlCEK1zfyd3zST5L5", // newrelease-openAI
  neo4j : "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"
};
module.exports = config;
//"sk-proj-2b8dmEGVjtPj2KqPSiY2T3BlbkFJwiI4DEol4kjUVp0Y36EB", //default-openAI